import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { financePartnerService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'financePartnerDetails',
  initialState: adapter.getInitialState({
    busy: false,
    childData: [],
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setChildData: (state, { payload }) => ({ ...state, childData: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchDetails = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financePartnerService.fetchDetails(params);
    dispatch(slice.actions.removeAll());
    dispatch(slice.actions.addOne(resData));
  } catch (err) {
    dispatch(slice.actions.addOne({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const withdrawInvoiceFinanceRequest = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    await financePartnerService.withdrawInvoiceFinanceRequest(params);
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const getFinanceDeals_Applicant = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financePartnerService.getFinanceDeals_Applicant(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const getFinanceDeals_NBFC = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financePartnerService.getFinanceDeals_NBFC(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const getFinancedDealDetails = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financePartnerService.getFinancedDealDetails(params);
    dispatch(slice.actions.setChildData(resData));
    dispatch(slice.actions.setBusy(false));
    return resData;
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchDetails,
  withdrawInvoiceFinanceRequest,
  getFinanceDeals_Applicant,
  getFinanceDeals_NBFC,
  getFinancedDealDetails,
};

const selectors = {
  ...adapter.getSelectors((state) => state.financePartnerDetails),
};

export { actions, selectors };

export default slice.reducer;
